import React, { useEffect } from 'react';
import { MainContainer, KzFrame } from '../';
import {
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { 
  NotFound,
} from '@kuaizhan/kz-frame';
import { flatSideData } from '../../routers/siteSideData';
import { WorkspacePage } from '../../pages';
import { getValueFromLocationSearch } from '../../utils/tools'

export default function MainRoute() {
  const siteRoutes = flatSideData('').filter(route => route.path);

  useEffect(() => {
    if (location.pathname === '/v4/workspace') {
      // @ts-ignore
      if (window.xqui && window.xqui.useStat) {
        // @ts-ignore
        window.xqui.useStat({
          category: '',
          page: 'workspace',
          action: 'enter',
          bizType: 2
        })
      }
    } else {
      // @ts-ignore
      if (window.xqui && window.xqui.useStat) {
        // @ts-ignore
        window.xqui.useStat({
          category: '',
          page: 'site_back_stage',
          action: 'enter',
          bizType: 2
        })
      }
    }
  }, [])

  const curTab = getValueFromLocationSearch('tab') || 0
  
  return(
    <MainContainer>
      <Switch>
        <Redirect from="/" exact to="/v4/workspace" />
        <Route path="/v4/workspace" exact component={WorkspacePage} /> 
        {siteRoutes.map(route => (
          route.sourceUrl ?
          <Route path={route.path} exact component={(props: any) => <KzFrame src={`${route.sourceUrl}?site_id=${props.match.params.siteId}&cur=${curTab}`} /> }/> :
          <Route path={route.path} exact component={route.component} />
        ))}
        <Route component={({ location }: { location: any }) => (<NotFound urlBase="/" location={location} />)} />
      </Switch>
    </MainContainer>
  )
}